import { render } from "./SectionPaymentPreparation.vue?vue&type=template&id=56760c1d&scoped=true"
import script from "./SectionPaymentPreparation.vue?vue&type=script&lang=js"
export * from "./SectionPaymentPreparation.vue?vue&type=script&lang=js"

import "./SectionPaymentPreparation.vue?vue&type=style&index=0&id=56760c1d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56760c1d"]])

export default __exports__